import { RippleGlobalOptions } from '@angular/material/core';

export class GlobalRippleOptions implements RippleGlobalOptions {
    disabled = true;
}
